import { http } from "../../utils/config";

const paymentAccountAPI = {
    getLists: (params = {}) => {
        const {
            page = 1,
            per_page = 15,
            search = '',
            status = '',
            sort_by = 'created_at',
            sort_order = 'desc'
        } = params;

        const queryParams = new URLSearchParams({
            page: page.toString(),
            per_page: per_page.toString(),
            sort_by,
            sort_order,
            ...(search && { search }),
            ...(status !== '' && { status })
        });

        return http.get(`/api/v1/payments/account?${queryParams}`);
    },

    getAccountAll: (params = {}) => {
        return http.get(`/api/v1/payments/account/all`, { params });
    },

    getAccount: (id) => http.get(`/api/v1/payments/account/${id}`),

    // Create or update payment account
    create: (accountData) => http.post(`/api/v1/payments/account`, accountData),
    updateOrCreate: (id, accountData) => http.put(`/api/v1/payments/account/${id}`, accountData),

    // Delete payment account
    deleteAccount: (id) => http.delete(`/api/v1/payments/account/${id}`),

    // Toggle status
    toggleStatus: (id) => http.patch(`/api/v1/payments/account/toggle-status/${id}`),
};

export const accountPaymentHelpers = {
  extractAccountPaymentData: (response) => {
    if (response.data && response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },

  extractAccountPaymentList: (response) => {
    if (response.data && response.success) {
      const data = response.data;
      return {
        accounts: data.data || [],
        pagination: {
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
          from: data.from,
          to: data.to,
          lastPage: data.last_page,
          nextPageUrl: data.next_page_url,
          prevPageUrl: data.prev_page_url
        }
      };
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
    return async (...args) => {
        try {
            const response = await apiFunction(...args);
            return response.data;
        } catch (error) {
            console.error("API Error:", error);

            if (error.response) {
                const { status, data } = error.response;
                switch (status) {
                    case 400:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 401:
                        throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
                    case 403:
                        throw new Error("Bạn không có quyền thực hiện thao tác này");
                    case 404:
                        throw new Error("Không tìm thấy thông tin");
                    case 422:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 500:
                        throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
                    default:
                        throw new Error(data.message || "Đã có lỗi xảy ra");
                }
            } else if (error.request) {
                throw new Error("Không thể kết nối đến server");
            } else {
                throw new Error(error.message || "Đã có lỗi xảy ra");
            }
        }
    };
};

// Wrapped API with error handling
export const paymentAccountAPIWithErrorHandling = {
    getLists: withErrorHandling(paymentAccountAPI.getLists),
    getAccountAll: withErrorHandling(paymentAccountAPI.getAccountAll),
    getAccount: withErrorHandling(paymentAccountAPI.getAccount),
    create: withErrorHandling(paymentAccountAPI.create),
    updateOrCreate: withErrorHandling(paymentAccountAPI.updateOrCreate),
    deleteAccount: withErrorHandling(paymentAccountAPI.deleteAccount),
    toggleStatus: withErrorHandling(paymentAccountAPI.toggleStatus),
};

export default paymentAccountAPI;
